import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/icon/arrow-circle-right-outline-blue.svg'


const _hoisted_1 = { class: "wrap-list-verpal-report" }
const _hoisted_2 = { class: "header-ctn" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "flex gap-4 items-center" }
const _hoisted_5 = { class: "flex gap-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px"}
}, null, -1)
const _hoisted_7 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_8 = { class: "table-verpal-report" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Tanggal"),
  /*#__PURE__*/_createElementVNode("th", null, "Kota Kejadian"),
  /*#__PURE__*/_createElementVNode("th", null, "Kondektur"),
  /*#__PURE__*/_createElementVNode("th", null, "Keterangan"),
  /*#__PURE__*/_createElementVNode("th", null, "Bukti"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = {
  class: "flex gap-4 items-center pl-4",
  style: {"border-left":"1px solid #ECEFF1"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check mr-2 font-bold text-sm" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Approved")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check mr-2 font-bold text-sm" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Approve")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.dataItem?.CodeSchedule), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.dataItem?.FirstRouteCityName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", null, [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataItem?.Verpals, (verpal, idx) => {
          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
            _createElementVNode("td", null, _toDisplayString(_ctx.moment(verpal.CreatedAt).format('DD-MM-YYYY')), 1),
            _createElementVNode("td", null, _toDisplayString(verpal.CurrentTerminal), 1),
            _createElementVNode("td", null, _toDisplayString(verpal.TransactionPp.CondecturName), 1),
            _createElementVNode("td", null, _toDisplayString(verpal.Description), 1),
            _createElementVNode("td", null, _toDisplayString(verpal.VerpalMedia.length) + " Bukti", 1),
            _createElementVNode("td", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", {
                  class: "color-blue-1 font-bold cursor-pointer",
                  onClick: ($event: any) => (_ctx.onDetail(verpal))
                }, "Lihat Detail", 8, _hoisted_12),
                (verpal.MsStatus.Code === _ctx.StatusVerpal.Approved)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      size: "small",
                      class: "btn-primary",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _hoisted_14
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      size: "small",
                      class: "btn-primary",
                      onClick: ($event: any) => (_ctx.approveAct(verpal.Id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}